
/* injects from baggage-loader */

CKEDITOR.plugins.add( 'colortext', {
	requires: 'panelbutton',
  lang: 'af,ar,bg,bn,bs,ca,cs,cy,da,de,el,en,en-au,en-ca,en-gb,eo,es,et,eu,fa,fi,fo,fr,fr-ca,gl,gu,he,hi,hr,hu,id,is,it,ja,ka,km,ko,ku,lt,lv,mk,mn,ms,nb,nl,no,pl,pt,pt-br,ro,ru,si,sk,sl,sq,sr,sr-latn,sv,th,tr,tt,ug,uk,vi,zh,zh-cn', // %REMOVE_LINE_CORE%
	icons: 'bgcolor,textcolor', // %REMOVE_LINE_CORE%
	hidpi: true, // %REMOVE_LINE_CORE%
	init: function( editor ) {

		var config = editor.config,
			lang = editor.lang.colortext, blockGlobal;

		if ( !CKEDITOR.env.hc ) {
			addButton( 'ColorText', 'fore', lang.textColorTitle, 1 );
		}

		function addButton( name, type, title, order ) {
			var style = new CKEDITOR.style( config[ 'colorText_foreStyle' ] ),
				colorBoxId = CKEDITOR.tools.getNextId() + '_colorBox';

			editor.ui.add( name, CKEDITOR.UI_PANELBUTTON, {
				label: title,
				title: title,
				className: 'cke_colortext',
				modes: { wysiwyg: 1 },
				editorFocus: 0,
				toolbar: 'colors,' + order,
				allowedContent: style,
				requiredContent: style,

				panel: {
					css: CKEDITOR.skin.getPath( 'editor' ),
					attributes: { role: 'listbox', 'aria-label': lang.panelTitle }
				},

			  rgb2rgba: function(rgb, alpha) {
					if (rgb && rgb.indexOf('a') == -1){
				    return rgb.replace(')', ', '+alpha+')').replace('rgb', 'rgba');
					}
					else
						return rgb
			  },

				getColor: function() {
			    var span = editor.elementPath().contains( isColorSpan );

			    return span ? span.getStyle( 'color' ) : null;

			    function isColorSpan( el ) {
			        return el.getStyle( 'color' );
			    }
				},

				onOpen: function(panel, block) {
					var color = this.getColor();
					color = this.rgb2rgba(color, 1);
			    var rgbaStringArray = color.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
		      var rgb = rgbaStringArray[0].split(', ')
		      var opacity = rgb[3]


					$(blockGlobal.element.$).find('.cke__colortext__input').data("hex", false)
					$(blockGlobal.element.$).find('.cke__colortext__input').val(color)
					$(blockGlobal.element.$).find('.cke__colortext__input').attr("data-opacity", opacity)
					$(blockGlobal.element.$).find('.cke__colortext__input').minicolors('value', color);

				},

				onBlock: function( panel, block ) {
					block.element.addClass( 'cke_colorblock' );
					block.element.getDocument().getBody().setStyle( 'overflow', 'hidden' );
					// editor.removeStyle( new CKEDITOR.style( config[ 'colorText_foreStyle' ], { color: 'inherit' } ) );
					blockGlobal = block

					$(block.element.$).append( '<input type="text" class="cke__colortext__input" data-opacity="1" value="#FFFFFF" />' );
					$(block.element.$).children('.cke__colortext__input').minicolors({
						opacity: 1,
						CKE: true,
						doc: block.element.getDocument().$,
						inline: true,
						change: function(hex, opacity) {
				      // new CKEDITOR.style( config[ 'colorText_foreStyle' ], { color: hex } ).apply(editor.document)
				      var colorStyle = config[ 'colorText_foreStyle' ];

							colorStyle.childRule = type == 'back' ?
							function( element ) {
								// It's better to apply background color as the innermost style. (#3599)
								// Except for "unstylable elements". (#6103)
								return isUnstylable( element );
							} : function( element ) {
								// Fore color style must be applied inside links instead of around it. (#4772,#6908)
								return !( element.is( 'a' ) || element.getElementsByTag( 'a' ).count() ) || isUnstylable( element );
							};

							new CKEDITOR.style( config[ 'colorText_foreStyle' ], { color: hex } ).apply(editor.document);
							new CKEDITOR.style( config[ 'colorTextLink_foreStyle' ], { color: hex } ).apply(editor.document);

				    }
					})
					function isUnstylable( ele ) {
						return ( ele.getAttribute( 'contentEditable' ) == 'false' ) || ele.getAttribute( 'data-nostyle' );
					}
					CKEDITOR.ui.fire( 'ready', this );
				},

				refresh: function(panel, block) {
					if ( !editor.activeFilter.check( style ) )
						this.setState( CKEDITOR.TRISTATE_DISABLED );
				}
			} );
		}
	}
} );

CKEDITOR.config.colorText_foreStyle = {
	element: 'span',
	styles: { 'color': '#(color)' },
	overrides: [ {
		element: 'font', attributes: { 'color': null }
	} ]
};
CKEDITOR.config.colorTextLink_foreStyle = {
	element: 'a',
	styles: { 'color': '#(color)' },
	overrides: [ {
		element: 'font', attributes: { 'color': null }
	} ]
};



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/colortext/plugin.js